import type { TFunction } from 'i18next';

import type { LogosCopy } from './logos-summary';

/**
 * The Logos card's copy: one literal `t()` key per id, so the extractor harvests every one; the `switch` is exhaustive,
 * so a new id fails the typecheck until it has its copy.
 */
export const logosCopy = (t: TFunction, c: LogosCopy): string => {
  switch (c.id) {
    case 'failed':
      return t('Failed');
    case 'generating':
      return t('Generating');
    case 'locked':
      return t('Locked');
    case 'last-change-failed':
      return t('Your last logo change failed');
    case 'all-logos-ready':
      return t('All {{n}} logos ready', { n: c.n });
    case 'logos-ready':
      return c.n === 1 ? t('1 logo ready') : t('{{n}} logos ready', { n: c.n });
    case 'preparing-logos':
      return t('Lumio is preparing your logos');
    case 'no-logos':
      return t('No logos yet');
    case 'open-logos':
      return t('Open logos');
    case 'download-all':
      return t('Download all');
    case 'replace-logo':
      return t('Replace logo');
  }
};
